import type { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface SectionProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  unpadded?: boolean;
}

export function Section({
  title,
  description,
  actions,
  children,
  className,
  contentClassName,
  unpadded,
}: SectionProps) {
  return (
    <Card className={cn('mb-4', className)}>
      {(title || description || actions) && (
        <CardHeader className="flex flex-row items-start justify-between gap-3 space-y-0">
          <div className="space-y-1">
            {title && <CardTitle className="text-lg">{title}</CardTitle>}
            {description && <CardDescription>{description}</CardDescription>}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </CardHeader>
      )}
      <CardContent className={cn(unpadded && 'p-0', contentClassName)}>{children}</CardContent>
    </Card>
  );
}

export default Section;
